import React from 'react'
import styled from 'styled-components'
import { pxToRem, color } from '../utils'

const Wrapper = styled.div`
  background: ${color.secondary};
  border-radius: ${pxToRem('7px')};
  padding: ${pxToRem('24px')};
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  h2{
    font-weight: 200;
  }
  a {
    color: #fff;
    font-weight: 800;
    text-decoration: underline;
    transition: .2s;
    -webkit-text-decoration-color: rgba(255, 255 , 255 , 255 .0); /* Safari */
    text-decoration-color: rgba(255, 255 , 255 , 0.0);
    &:hover,
    &:focus {
      -webkit-text-decoration-color: rgba(255, 255 , 255 , 255 .8); /* Safari */
      text-decoration-color: rgba(255, 255 , 255 , 0.8);
    }
    &:active {
      -webkit-text-decoration-color: rgba(255, 255 , 255 , 255 1); /* Safari */
      text-decoration-color: rgba(255, 255 , 255 , 1);
    }
  }
`

const Welcome = props => {
  const { children, ...rest } = props;
  return (
    <Wrapper {...rest}>{children}</Wrapper>
  )
}

export default Welcome



// WEBPACK FOOTER //
// ./src/components/Welcome.js